import React from 'react';
import { 
  FaInbox, 
  FaSearch, 
  FaExclamationTriangle, 
  FaFileAlt, 
  FaRegSadTear 
} from 'react-icons/fa';

/**
 * 空状态组件 - 用于显示无数据、搜索无结果等空状态
 * @param {string} type - 空状态类型: 'no-data'|'empty'|'no-results'|'error'|'coming-soon'
 * @param {string} title - 标题
 * @param {string} message - 描述信息
 * @param {node} action - 操作按钮或链接
 * @param {string} iconSize - 图标大小
 * @param {string} className - 额外的CSS类名
 */
const EmptyState = ({ 
  type = 'empty',
  title, 
  message, 
  action,
  iconSize = '3rem',
  className = '',
}) => {
  // 根据类型选择图标
  const renderIcon = () => {
    const iconStyle = { fontSize: iconSize };
    
    switch (type) {
      case 'no-data':
        return <FaInbox style={iconStyle} className="text-muted mb-3" />;
      case 'no-results':
        return <FaSearch style={iconStyle} className="text-muted mb-3" />;
      case 'error':
        return <FaExclamationTriangle style={iconStyle} className="text-danger mb-3" />;
      case 'coming-soon':
        return <FaFileAlt style={iconStyle} className="text-primary mb-3" />;
      case 'empty':
      default:
        return <FaRegSadTear style={iconStyle} className="text-muted mb-3" />;
    }
  };

  return (
    <div className={`empty-state text-center py-5 ${className}`}>
      <div className="empty-state-content p-4">
        {renderIcon()}
        
        {title && <h5 className="mb-2">{title}</h5>}
        
        {message && <p className="text-muted mb-4">{message}</p>}
        
        {action && <div className="mt-3">{action}</div>}
      </div>
    </div>
  );
};

export default EmptyState; 